import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  TextField,
  Autocomplete,
  Select,
  MenuItem,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import GetChargeAccount from "../Dropdowns/GetChargeAccount";
import CostCenter from "../Dropdowns/CostCenter";
import GetHorizonID from "../Dropdowns/GetHorizonID";
import {
  getCostCenterDataForExcel,
  getEmployeeByCostCenter,
  getHorizonID_Data,
  getVendorDetail,
  getg_laccountForExcel,
  getCostCenterData_v2,
  getg_laccount_Search,
} from "../../actions";
import VendorCode from "../Dropdowns/VenderCode";
import "./style.css";
import { Delete } from "@material-ui/icons";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import POAlertDialog from "./PoTableAlert";
import getParameterByName from "../../../../Functions/functions";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
  intColumn,
  floatColumn,
  resizeColumn,
} from "react-datasheet-grid";
import axios from "axios";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});
const GL_Table = ({ formState, setFormState, show, reviwerFlag }) => {
  const tableData = {
    rowId: "",
    accountId: 0,
    invoice_Id: Number(formState.invoice_Id), // number for departCord
    glAccount: "",
    accountType: "Debit",
    costCenter: "",
    costCenterOwner: "",
    costCenterOwnerName: "",
    wbsElement: "",
    horizonId: "",
    vendor_Code: "",
    amount: 0,
    profitCenter: "",
    department: "",
    description: `${formState.invoice_Desc}`,
  };

  const edit = getParameterByName("edit");

  const classes = useStyles();
  const [horizonIDList, setHorizonIDList] = useState([]);
  const [horizonLoading, setHorizonLoading] = useState(false);

  const [vendorList, setVendorList] = useState([]);
  const [gl_account, setGl_account] = useState([]);

  const [vendorListLoading, setVendorListLoading] = useState(false);

  const [costCenterList, setCostCenterList] = useState([]);
  const [costCenterLoading, setCostCenterLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [erralertMessage, setErrAlertMessage] = useState("");
  const [vendorblock, setvendorblock] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0.0);

  const [costCenterEmployeeLoading, setCostCenterEmployeeLoading] =
    useState(false);
  const [CostLoading, setCostLoading] = useState([]);
  const [glAccountLoading, setGlAccountLoading] = useState(false);
  const [activeCell, setActiveCell] = useState("");

  useEffect(() => {
    getHorizonID_Data(setHorizonLoading, setHorizonIDList);
    // getCostCenterDataForExcel(
    //   "",
    //   setCostCenterLoading,
    //   setCostCenterList,
    //   setCostLoading
    // );
    getVendorDetail("", setVendorList, setVendorListLoading);
    // getg_laccountForExcel("", setLoading, setGl_account, setGlAccountLoading);
  }, []);
  const roleName = getParameterByName("roleName");

  const addInput = () => {
    const num = Math.random();
    tableData.rowId = num;
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: [...formState.invoice_Accounts_list, tableData],
    }));
  };
  const deleteInput = (index, rowId) => {
    const filteredData = formState?.invoice_Accounts_list?.filter(
      (x, i) => x?.rowId !== rowId
    );
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: filteredData,
    }));
  };

  const changeHandler = (e, index) => {
    const { name, value } = e.target;

    let tempArray = formState.invoice_Accounts_list;
    // if((name == 'costCenter' && !tempArray[index] )){}
    tempArray[index] = {
      ...formState.invoice_Accounts_list[index],
      [name]: value,
    };
    if (name === "horizonId") {
      let selectedItem = {};
      for (let i = 0; i < horizonIDList.length; i++) {
        const element = horizonIDList[i];
        if (element.employeeCode === value) {
          selectedItem = element;
          break;
        }
      }
      tempArray[index] = {
        ...formState.invoice_Accounts_list[index],
        department: selectedItem.department
          ? selectedItem.department
          : "Not Found",
      };
    }
    if (name === "Vendor_Code") {
      tempArray[index] = {
        ...formState.invoice_Accounts_list[index],
        vendorCode: value,
      };
    }

    setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: tempArray,
    }));
  };

  const adjustAmountOnGLTable = (tempArr) => {
    let newAmount = Number(formState?.invoice_Amount);
    if (tempArr.length > 0) {
      for (let i = 0; i < tempArr.length; i++) {
        const item = tempArr[i];
        newAmount = newAmount - Number(item.amount);
      }
    }
    return newAmount;
  };

  const handleGridChange = async (data, operation, rowKey) => {
    const index = operation[0]?.fromRowIndex;
    if (operation[0].type === "CREATE") {
      const num = Math.random();
      tableData.rowId = num;

      setFormState((formState) => ({
        ...formState,
        invoice_Accounts_list: [...formState.invoice_Accounts_list, tableData],
      }));
    } else if (operation[0].type === "DELETE") {
      const filteredData = formState?.invoice_Accounts_list?.filter(
        (x, i) => i !== index
      );
      setFormState((formState) => ({
        ...formState,
        invoice_Accounts_list: filteredData,
      }));
    } else if (operation[0].type === "UPDATE") {
      // if (index === 0 && data[index]?.glAccount) {
      //   // Autofill amount based on your logic, replace this line accordingly
      //   data[index].amount = Number(formState.invoice_Amount);

      // }
      if (activeCell === "glAccount") {
        if (data[index]?.glAccount) {
          setActiveCell("");
          data[index].amount = adjustAmountOnGLTable(
            formState?.invoice_Accounts_list
          );
        }
      }
      let updatedData = await Promise.all(
        data.map(async (row) => {
          const selectedItem = horizonIDList.find(
            (horizonID) => horizonID.employeeCode === row?.horizonId
          );

          if (!row.department) {
            row.department = selectedItem?.department
              ? selectedItem?.department
              : row?.horizonId
              ? "Not Found"
              : "";
          }

          let ab = { costCenterData: "" };
          if (row?.costCenter) {
            await getEmployeeByCostCenter(row?.costCenter, setLoading, ab);
          }

          row.costCenterOwner = row?.costCenter
            ? ab.costCenterData.employeeCode
              ? ab.costCenterData.employeeCode
              : "No Found"
            : "";
          row.costCenterOwnerName = row?.costCenter
            ? ab.costCenterData.employeeName
              ? ab.costCenterData.employeeName
              : "Not Found"
            : "";

          // Copy all properties from tableData to the current row

          return {
            ...row,
            rowId: "",
            accountId: 0,
            invoice_Id: Number(formState.invoice_Id), // number for departCord
            glAccount: row.glAccount || "",
            accountType: "Debit",
            wbsElement: row.wbsElement || "",
            horizonId: row?.horizonId || "",
            amount: row?.amount || 0,
            profitCenter: row?.profitCenter || "",
            description: row?.description || "",
          };
        })
      );
      setFormState((formState) => ({
        ...formState,
        invoice_Accounts_list: updatedData,
      }));
    }
  };
  // const CostCenterComponent = React.memo(
  //   ({
  //     active,
  //     rowData,
  //     setRowData,
  //     focus,
  //     stopEditing,
  //     columnData,
  //     disabled,
  //   }) => {
  //     const ref = useRef(null);

  //     //
  //     useEffect(() => {
  //       if (focus) {
  //         ref.current?.focus();
  //       } else {
  //         ref.current?.blur();
  //       }
  //     }, [focus]);
  //     const [choices, setChoices] = useState(columnData.choices);

  //     // useEffect(() => {
  //     //   getCostCenterData_v2(rowData, setLoading, setChoices);

  //     //   // getCostCenterDataByID(rowData);
  //     // }, [rowData]);

  //     return (
  //       <>
  //         <FormControl fullWidth>
  //           <Autocomplete
  //             ref={ref}
  //             style={{ width: "100%" }}
  //             disabled={reviwerFlag || disabled}
  //             // value={
  //             //   // Ensure that rowData is an object before trying to access its properties
  //             //   rowData
  //             //     ? columnData.choices.find(
  //             //         (option) =>
  //             //           option.data.CostCenterCode === rowData?.CostCenterCode
  //             //       )
  //             //     : null
  //             // }
  //             value={
  //               // Ensure that rowData is an object before trying to access its properties
  //               rowData
  //                 ? choices.find(
  //                     (option) => option.data?.CostCenterCode === rowData
  //                   ) || {
  //                     value: "",
  //                     label: "",
  //                   }
  //                 : null
  //             }
  //             onChange={(event, newValue) => {
  //               if (!newValue) {
  //                 setRowData("");
  //               } else {
  //                 const selectedVendor = newValue?.value;
  //                 setRowData(selectedVendor);
  //                 setTimeout(stopEditing, 0);
  //               }

  //               if (
  //                 newValue?.data?.IsActive != "True" &&
  //                 newValue?.data != null
  //               ) {
  //                 setAlertMessage(true);
  //                 setErrAlertMessage("This Cost Center  has been Blocked");
  //               }
  //             }}
  //             options={choices}
  //             getOptionLabel={(option) => option?.label}
  //             loading={costCenterLoading}
  //             renderInput={(params) => (
  //               <TextField
  //                 {...params}
  //                 variant="standard"
  //                 InputProps={{
  //                   ...params.InputProps,
  //                   disableUnderline: true,
  //                 }}
  //                 size="small"
  //                 // onChange={(event) => {
  //                 //   getCostCenterData_v2(
  //                 //     event.target.value,
  //                 //     setLoading,
  //                 //     setChoices
  //                 //   );
  //                 // }}
  //                 // required
  //               />
  //             )}
  //           />
  //         </FormControl>
  //       </>
  //     );
  //   }
  // );
  // const SelectComponent = React.memo(
  //   ({ active, rowData, setRowData, focus, stopEditing, columnData }) => {
  //     const ref = useRef(null);
  //     //
  //     useEffect(() => {
  //       if (focus) {
  //         ref.current?.focus();
  //       } else {
  //         ref.current?.blur();
  //       }
  //     }, [focus]);
  //     const [choices, setChoices] = useState(columnData.choices);

  //     // useEffect(() => {
  //     //   getg_laccount_Search(rowData, setLoading, setChoices);
  //     // }, [rowData]);

  //     return (
  //       <>
  //         <FormControl fullWidth>
  //           <Autocomplete
  //             ref={ref}
  //             style={{ width: "100%" }}
  //             disabled={reviwerFlag}
  //             value={
  //               // Ensure that rowData is an object before trying to access its properties
  //               rowData
  //                 ? choices.find((option) => option.value === rowData) || {
  //                     value: "",
  //                     label: "",
  //                   }
  //                 : null
  //             }
  //             onChange={(event, newValue) => {
  //               if (!newValue) {
  //                 setRowData("");
  //               } else {
  //                 const selectedVendor = newValue?.value;
  //                 setRowData(selectedVendor);
  //                 setTimeout(stopEditing, 0);
  //               }

  //               if (
  //                 newValue?.data?.IsActive != "True" &&
  //                 newValue?.data != null
  //               ) {
  //                 setAlertMessage(true);
  //                 setErrAlertMessage("This Gl Account has been Blocked");
  //               }
  //             }}
  //             options={choices}
  //             getOptionLabel={(option) => option?.label}
  //             loading={loading}
  //             renderInput={(params) => (
  //               <TextField
  //                 {...params}
  //                 variant="standard"
  //                 size="small"
  //                 // onChange={(event) => {
  //                 //   getg_laccount_Search(
  //                 //     event.target.value,
  //                 //     setLoading,
  //                 //     setChoices
  //                 //   );
  //                 // }}
  //                 // required
  //                 InputProps={{ ...params.InputProps, disableUnderline: true }}
  //               />
  //             )}
  //           />
  //         </FormControl>
  //       </>
  //     );
  //   }
  // );

  const DebitCreditComponent = React.memo(
    ({ active, rowData, setRowData, focus, stopEditing, columnData }) => {
      const ref = useRef(null);

      //
      useEffect(() => {
        if (focus) {
          ref.current?.focus();
        } else {
          ref.current?.blur();
        }
      }, [focus]);

      return (
        <>
          <FormControl fullWidth>
            <Autocomplete
              ref={ref}
              style={{ width: "100%" }}
              disabled={reviwerFlag}
              value={
                // Ensure that rowData is an object before trying to access its properties
                rowData
                  ? columnData.choices.find(
                      (option) => option?.data?.value === rowData
                    )
                  : null
              }
              onChange={(event, newValue) => {
                // const selectedVendor = newValue?.label;
                // const selectedData = {
                //   label: newValue.label,
                //   value: newValue.value, // Assuming the actual value is stored in 'data.value'
                // };

                // setRowData( newValue?.label);
                setRowData(newValue?.data?.value);

                setTimeout(stopEditing, 0);
              }}
              options={columnData.choices}
              getOptionLabel={(option) => option?.data?.label}
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  size="small"
                  // required
                />
              )}
            />
          </FormControl>
        </>
      );
    }
  );
  // const intColumn = {
  //   component: AmountCell,
  //   deleteValue: () => "",
  //   copyValue: ({ rowData }) => rowData,
  //   pasteValue: ({ value }) => value,
  // };

  // const selectColumn = (options) => ({
  //   component: SelectComponent,
  //   columnData: options,
  //   disableKeys: true,
  //   keepFocus: true,

  //   copyValue: ({ rowData }) => rowData,
  //   pasteValue: ({ value }) => {
  //     const paddedValue = value.padStart(10, "0");
  //     return paddedValue;
  //   },
  // });
  // const costselectColumn = (options) => ({
  //   component: CostCenterComponent,
  //   columnData: options,
  //   disableKeys: true,
  //   keepFocus: true,

  //   copyValue: ({ rowData }) => {
  //     return rowData;
  //   },
  //   pasteValue: ({ value }) => {
  //     return value;
  //   },
  // });

  const horizonIdselectColumn = (options) => ({
    component: DebitCreditComponent,
    columnData: options,
    disableKeys: true,
    keepFocus: true,

    // copyValue: ({ rowData }) => rowData,
    // pasteValue: ({ value }) => value,
    copyValue: ({ rowData }) => {
      const selectedChoice = options.choices.find(
        (choice) => choice?.data?.value === rowData
      );

      return selectedChoice ? selectedChoice?.data?.label : "";
    },
    pasteValue: ({ value }) => {
      const selectedChoice = options.choices.find(
        (choice) => choice?.data?.label === value
      );

      return selectedChoice ? selectedChoice.data.value : null;
    },
  });
  const columns = [
    {
      ...keyColumn("glAccount", textColumn),
      // ...keyColumn(
      //   "glAccount",

      //   selectColumn({
      //     choices: gl_account?.map((account, i) => ({
      //       data: account,
      //       value: `${account.GLAccount}`,
      //       label: `${account.GLAccount} - ${account.ShortText}`,
      //     })),
      //   })
      // ),
      title: "GL Account",
      minWidth: 340,
      disabled: true,
    },
    {
      ...keyColumn("amount" || "Amount", floatColumn),
      title: "Amount",
      minWidth: 200,
      // width: 150,
      // disabled: true,
      disabled: reviwerFlag || true,
      defaultValue: "0",
      pasteValue: ({ rowData, value, rowIndex }) => {
        rowData.amount = Number(value.replace(/,/g, "")) || 0;
        return rowData;
      },

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      ...keyColumn("costCenter", textColumn),
      // ...keyColumn(
      //   "costCenter" || "CostCenter",
      //   costselectColumn({
      //     choices: costCenterList?.map((account, i) => ({
      //       data: account,
      //       value: `${account.CostCenterCode}`,
      //       label: `${account.CostCenterCode} - ${account.Name}`,
      //     })),
      //   })
      // ),
      title: "Cost Center",
      minWidth: 340,

      disabled: true,
      // disabled: ({ rowData }) => {
      //   if (rowData?.profitCenter || reviwerFlag) {
      //     return true;
      //   }
      //   // debugger
      //   return false;
      // },
    },
    {
      ...keyColumn("costCenterOwnerName" || "CostCenterOwnerName", textColumn),
      title: "CC owner",
      minWidth: 300,

      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      ...keyColumn("profitCenter" || "ProfitCenter", intColumn),
      title: "Profit Center",
      // disabled: reviwerFlag,
      disabled: ({ rowData }) => {
        if (rowData?.costCenter || reviwerFlag) {
          return true;
        }

        return false;
      },
    },
    //   show
    // && {
    //       ...keyColumn("wbsElement", textColumn),
    //       title: "WBS Element",
    //       minWidth: 140,
    //     }
    //   ,
    //  show ?{
    //     ...keyColumn("description", textColumn),
    //     title: "Text",

    //     // disabled: true,
    //     disabled: reviwerFlag,

    // }:"",
  ];
  if (!show) {
    columns?.splice(1, 0, {
      ...keyColumn(
        "horizonId" || "HorizonId",
        horizonIdselectColumn({
          choices: horizonIDList?.map((item, i) => ({
            data: {
              value: `${item?.employeeCode}`,
              label: `${item?.employeeCode}-${item?.employeeName}`, // Assuming the actual value is stored in 'data.value'
            },
          })),
        })
      ),
      title: "P# / Horizon ID",
      minWidth: 210,
      disabled: reviwerFlag || true,
    });
  }

  if (!show) {
    columns?.splice(3, 0, {
      ...keyColumn("department" || "Department", textColumn),
      title: "Department",
      // width: 150,
      minWidth: 160,

      disabled: reviwerFlag || "true",

      // disabled: ({ disabled }) => (disabled ? true : false),
    });
  }
  if (show) {
    columns.push({
      ...keyColumn("wbsElement" || "WBSElement", textColumn),
      title: "WBS Element",
      minWidth: 140,
      disabled: ({ rowData }) => {
        if (rowData?.costCenter || reviwerFlag) {
          return true;
        }

        return false;
      },
    });
  }
  if (show) {
    columns.push({
      ...keyColumn("description" || "Description", textColumn),
      title: "Text",
      disabled: reviwerFlag,
      minWidth: 360,
    });
  }

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
        {/* <TableContainer className="scrollable">
          <Table
            aria-label="simple table"
            className={classes.table}
            size="small"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EFF2F4", width: "100%" }}>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  GL Account <span style={{ color: "red" }}>*</span>
                </TableCell>
                {!show && (
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    P# / Horizon ID
                  </TableCell>
                )}
                {!show && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    style={{ width: "14%" }}
                  >
                    Vendor Name{" "}
                  </TableCell>
                )}
                {!show && (
                  <TableCell
                    style={{
                      padding: 0,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#031C30",
                      width: "140px",
                    }}
                  >
                    Deparment{" "}
                  </TableCell>
                )}

                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Amount <span style={{ color: "red" }}>*</span>
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Cost Cent <span style={{ color: "red" }}>*</span>
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  CC Owner
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Profit Cent
                </TableCell>
                {show && (
                  <TableCell
                    style={{
                      padding: 0,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#031c30",
                      // width: "10%"
                    }}
                  >
                    WBS Element{" "}
                  </TableCell>
                )}
                {show && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031c30" }}
                    // style={{ width: "11%" }}
                  >
                    Text
                  </TableCell>
                )}

                {!reviwerFlag && (
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Action
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {formState[
                edit === "false" ? "invoice_Accounts" : "invoice_Accounts_list"
              ]?.map((item, index) => {
                const vendorObj = {
                  Vendor_Code: item.VenderCode,
                };
                return (
                  <TableRow>
                  // GLAccount 
                    <TableCell scope="row">
                      <FormControl fullWidth size="small">
                        <GetChargeAccount
                          GLAccount={item?.glAccount}
                          item={item}
                          changeHandler={changeHandler}
                          index={index}
                          bordered={false}
                          disabled={reviwerFlag}
                          setAlertMessage={setAlertMessage}
                          setErrAlertMessage={setErrAlertMessage}
                        />
                      </FormControl>
                    </TableCell>
                    //horizonIDList 
                    {!show && (
                      <TableCell>
                        <FormControl fullWidth size="small">
                          <GetHorizonID
                            value={item.horizonId}
                            changeHandler={changeHandler}
                            loading={horizonLoading}
                            horizonIDList={horizonIDList}
                            index={index}
                          />
                        </FormControl>
                      </TableCell>
                    )}
                    // VendorCode 
                    {!show && (
                      <TableCell>
                        <FormControl fullWidth size="small">
                          <VendorCode
                            // disabled={false}
                            // formState={vendorObj}
                            // changeHandler={changeHandler}
                            // user={null}
                            // vendorCodeOnly={false}
                            // index={index}
                            // bordered={false}
                            disabled={false}
                            formState={item}
                            changeHandler={changeHandler}
                            user={null}
                            vendorCodeOnly={true}
                            index={index}
                            bordered={false}
                            setvendorblock={setvendorblock}
                            setErrAlertMessage={setErrAlertMessage}
                          />
                        </FormControl>
                      </TableCell>
                    )}
                    // Deparment Cell 
                    {!show && (
                      <TableCell sx={{ width: "100px" }}>
                        {" "}
                        {item.department}
                      </TableCell>
                    )}
                    <TableCell>
                      <TextField
                        // fullWidth
                        value={item?.amount}
                        style={{ width: "200" }}
                        variant="standard"
                        type="number"
                        size="small"
                        name="amount"
                        disabled={reviwerFlag}
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        onChange={(event) => changeHandler(event, index)}
                        id="outlined-basic"
                        // InputProps={{ disableUnderline: true }}
                      />
                    </TableCell>
                    <TableCell>
                      <FormControl fullWidth size="small">
                        <CostCenter
                          // value={item.costCenter}
                          value={
                            item?.costCenter ||
                            item?.CostCenter || {
                              CostCenterCode: "",
                              Name: "",
                            }
                          }
                          changeHandler={changeHandler}
                          costCenter={item?.costCenter?.CostCenterCode || ""}
                          index={index}
                          bordered={false}
                          disabled={
                            reviwerFlag
                              ? true
                              : item?.profitCenter
                              ? true
                              : false
                          }
                          setAlertMessage={setAlertMessage}
                          setErrAlertMessage={setErrAlertMessage}
                        />
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <TextField
                        disabled
                        size="small"
                        style={{ width: "200" }}
                        variant="standard"
                        type="text"
                        fullWidth
                        value={`${item?.costCenterOwner || ""} ${
                          item?.costCenterOwnerName || item?.CostCenterOwnerName
                            ? "-"
                            : ""
                        } ${
                          item?.costCenterOwnerName ||
                          item?.CostCenterOwnerName ||
                          ""
                        }`}
                        //  InputProps={{ disableUnderline: true }}
                      ></TextField>
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={item?.profitCenter || ""}
                        type="number"
                        name="profitCenter"
                        size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        disabled={
                          reviwerFlag ? true : item?.costCenter ? true : false
                        }
                        id="outlined-basic"
                        variant="standard"
                        onChange={(event) => changeHandler(event, index)}
                        required={
                          item?.costCenter || item?.CostCenter ? false : true
                        }
                        // InputProps={{ disableUnderline: true }}
                      />
                    </TableCell>
                    {show && (
                      <TableCell>
                        <TextField
                          // fullWidth
                          value={item?.wbsElement || ""}
                          type="text"
                          size="small"
                          name="wbsElement"
                          disabled={
                            reviwerFlag ? true : item?.costCenter ? true : false
                          }
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          onChange={(event) => changeHandler(event, index)}
                          id="outlined-basic"
                          variant="standard"
                        />
                      </TableCell>
                    )}
                    {show && (
                      <TableCell sx={{ padding: "10px" }}>
                        <TextField
                          // fullWidth
                          type="text"
                          size="small"
                          name="description"
                          value={item?.description || item?.Description}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          disabled={reviwerFlag}
                          onChange={(event) =>
                            changeHandler(event, index, item.rowId)
                          }
                          id="outlined-basic"
                          variant="standard"
                          // InputProps ={{disableUnderline : true}}
                        />
                      </TableCell>
                    )}

                    {!reviwerFlag && (
                      <TableCell align="center">
                        <Delete
                          color="error"
                          onClick={() => {
                            deleteInput(index, item?.rowId);
                          }}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {formState[edit === "false" ? "invoice_Accounts" : "invoice_Accounts_list"]
            ?.length === 0 ? (
            <EmptyData />
          ) : (
            ""
          )}
          <Grid container spacing={0} mt={1}>
            <Grid item>
              <b>Total GL Amount:</b>
            </Grid>
            <Grid item style={{ paddingLeft: "4px" }}>
              <b>
                {formState[edit === "false"  ? "invoice_Accounts" : "invoice_Accounts_list"]
                  ?.map((data) => data.amount)
                  .reduce((prev, curr) => Number(prev) + Number(curr), 0)}
              </b>
            </Grid>
          </Grid>
        </TableContainer> */}

        <DataSheetGrid
          style={{
            "--dsg-header-text-color": "#031C30",
          }}
          value={
            formState.invoice_Accounts_list?.length === 0
              ? [tableData]
              : [
                  ...formState?.invoice_Accounts_list?.map((item) => {
                    const newItem = { ...item };
                    if (newItem.hasOwnProperty("amount")) {
                      newItem["amount"] = Number(
                        Number(newItem["amount"])?.toFixed(2)
                      );
                    } else if (newItem.hasOwnProperty("Amount")) {
                      newItem["Amount"] = Number(
                        Number(newItem["Amount"])?.toFixed(2)
                      );
                    }
                    return newItem;
                  }),
                ]
          }
          onChange={handleGridChange}
          onActiveCellChange={({ cell }) => {
            setActiveCell(cell?.colId || "");
          }}
          columns={columns}
          lockRows={reviwerFlag}
        />

        {/* <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
            <LinearProgress color="info" />
            <LinearProgress color="info" />
            <LinearProgress color="info" />
          </Stack> */}
        {/* <Grid container spacing={0} mt={1}>
  <Grid item>
    <b>Balance:</b>
   
    </Typography>
  </Grid>
  <Grid item style={{ paddingLeft: "4px" }}>
    <b>{balance}</b>
  </Grid> */}
        {/* {!reviwerFlag && (
          <Box
            display="flex"
            justifyContent={"flex-end"}
            mt={2}
            // style={{display : `${edit === "true" ? "" : "none"}`}}
          >
            <Button color="secondary" variant="contained" onClick={addInput}>
              Add New Row
            </Button>
          </Box>
        )} */}
        {alertMessage && (
          <POAlertDialog
            setAlertMessage={setAlertMessage}
            message={erralertMessage}
            setErrAlertMessage={() => {}}
          />
        )}
        {vendorblock && (
          <POAlertDialog
            setAlertMessage={setvendorblock}
            message={erralertMessage}
            setErrAlertMessage={() => {}}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default React.memo(GL_Table);
